import { BatchType } from '../../types/batchActions';

export const BATCH_TYPES_THAT_KEEP_SELECTION = [
  BatchType.TITLE,
  BatchType.DESCRIPTION,
  BatchType.TAGS,
  BatchType.GALLERY,
  BatchType.TIER,
  BatchType.DISPLAY_OPTIONS,
  BatchType.LICENSE,
  BatchType.ATTRIBUTE,
  BatchType.PRESET,
  BatchType.LABELS,
  BatchType.SCHEDULE,
];
